import { GlobalScope_instance3w3xrcgjszz2p as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  writer1eia5its2a1fh as writer,
  writeFullyuc6cd2hh6ex3 as writeFully,
  close3semq7pafb42g as close,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { get_ByteArrayPool3f7yrgvqxz9ct as get_ByteArrayPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/ByteArrayPool.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { readAvailable2yaaricqompas as readAvailable } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function observable(_this__u8e3s4, context, contentLength, listener) {
  var tmp = GlobalScope_instance;
  return writer(tmp, context, true, observable$slambda(_this__u8e3s4, listener, contentLength)).b4l_1;
}
function observable$slambda($this_observable, $listener, $contentLength) {
  return constructCallableReference(function *($this$writer, $completion) {
    var tmp0 = get_ByteArrayPool();
    $l$block: {
      // Inline function 'io.ktor.utils.io.pool.useInstance' call
      var instance = tmp0.u4m();
      try {
        var bytesSend = 0n;
        $l$loop: while (!$this_observable.e4k()) {
          var read = yield* readAvailable($this_observable, instance, VOID, VOID, $completion);
          if (read <= 0)
            continue $l$loop;
          yield* writeFully($this$writer.l4l_1, instance, 0, read, $completion);
          // Inline function 'kotlin.Long.plus' call
          var this_0 = bytesSend;
          bytesSend = add(this_0, fromInt(read));
          yield* $listener.j5l(bytesSend, $contentLength, $completion);
        }
        var closedCause = $this_observable.z4j();
        close($this$writer.l4l_1, closedCause);
        if (closedCause == null && bytesSend === 0n) {
          yield* $listener.j5l(bytesSend, $contentLength, $completion);
        }
        break $l$block;
      }finally {
        tmp0.v4m(instance);
      }
    }
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  observable as observable2pw4p3n7s3klf,
};
//endregion

//# sourceMappingURL=ByteChannelUtils.mjs.map
